export default __webpack_public_path__ + "static/4_26-9a6f68b59cc0ca2eb718e6a61c6ed993.png";